import React from 'react';
import DepartmentsPage from './DepartmentsPage';
import { connect } from 'react-redux';
import { configureActions } from '../../../../actions/configure.action';
import helper from '../../../../utils/helper';
import moment from 'moment';

class Departments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      departments: [],
      isFetching: false,
      errors: '',
      openModal: false,
      selectedRow: null,
    };
    this.columns = [
      {
        dataField: 'id',
        text: 'ID',
        headerStyle: { width: 30 },
      },
      { dataField: 'name', text: 'Name', sort: true },
      {
        dataField: 'description',
        text: 'Description',
        headerStyle: { width: '30%' },
        sort: true,
      },
      {
        dataField: 'userLicenseUsed',
        text: 'Users',
        sort: true,
        formatter: (cell, row) =>
          this.colorizeUserOrSensor(cell, 'licensedUserCount', row),
      },
      {
        dataField: 'sensorLicenseUsed',
        text: 'Sensors',
        sort: true,
        formatter: (cell, row) =>
          this.colorizeUserOrSensor(cell, 'licensedSensorCount', row),
      },
      {
        dataField: 'licenseExpirationDate',
        text: 'Expiration Date',
        sort: true,
        headerStyle: { width: '20%' },
        formatter: (cell) => (
          <span style={{ color: this.colorizeExpDate(cell) }}>{cell}</span>
        ),
      },
    ];
    this.defaultSorted = [
      {
        dataField: 'name',
        order: 'asc',
      },
    ];
    this.ctxMenuOptions = [
      [
        {
          name: 'Add license',
          action: (row, rowIndex) => {
            this.props.history.push(`departments/add-license/${row.id}`);
          },
        },
        {
          name: 'View license',
          action: (row, rowIndex) => {
            this.props.history.push(`departments/view-license/${row.id}`);
          },
        },
        {
          name: 'Department settings',
          action: (row, rowIndex) => {
            this.props.history.push(
              `/configure/departments/department-settings/${row.id}`,
            );
          },
        },
        {
          name: 'Delete department',
          // className: (row, rowIndex) => {
          //   if (row) {
          //     return row.numGroups ? 'item-disable' : '';
          //   }
          // },
          action: (row, rowIndex) => {
            this.setState({ openModal: true, selectedRow: row });
          },
        },
      ],
    ];
  }

  colorizeUserOrSensor = (cell, target, row) => {
    if (!row.licneseCreationDate) {
      return (
        <span style={{ color: 'red' }}>
          {cell ? cell : '-'} /{row[target] ? row[target] : '-'}
        </span>
      );
    }
    return (
      <div>
        {cell ? (
          <span
            style={{
              color: this.isOver(cell, row[target]) ? 'red' : 'black',
            }}
          >
            {cell}
          </span>
        ) : (
          '-'
        )}{' '}
        /{row[target] ? row[target] : '-'}
      </div>
    );
  };

  isOver = (cell, target) => {
    if (Number.isNaN(parseInt(target))) {
      return false;
    }
    return parseInt(cell) > parseInt(target);
  };

  colorizeExpDate = (cell) => {
    if (cell) {
      if (moment(new Date()).isAfter(moment(new Date(cell)))) {
        return 'red';
      } else {
        if (moment(new Date(cell)).diff(moment(new Date()), 'days') < 30) {
          return 'goldenrod';
        }
      }
      return 'black';
    }
    return 'black';
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.configure.departments !== prevState.departments) {
      state.departments = nextProps.configure.departments;
    }
    state.errors = helper.centralizeError([nextProps.configure.errors]);
    return Object.keys(state).length ? state : null;
  }

  componentDidMount() {
    this.setState({ isFetching: true }, async () => {
      await this.props
        .getDepartments()
        .then(() => this.setState({ isFetching: false }));
    });
  }

  onCancel = () => {
    this.setState({ openModal: false, selectedRow: null });
  };

  onDeleteDepartment = () => {
    const { selectedRow } = this.state;
    this.setState(
      { openModal: false, isFetching: true },
      async () =>
        await this.props
          .deleteDepartment(selectedRow.id)
          .then(
            async () =>
              await this.props
                .getDepartments()
                .then(() => this.setState({ isFetching: false })),
          ),
    );
  };

  render() {
    return (
      <DepartmentsPage
        {...this.state}
        columns={this.columns}
        defaultSorted={this.defaultSorted}
        ctxMenuOptions={this.ctxMenuOptions}
        onCancel={this.onCancel}
        onDeleteDepartment={this.onDeleteDepartment}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
  };
}

export default connect(mapStateToProps, configureActions)(Departments);
